import { compose } from 'redux';
import actionTypes from './actionTypes';
import { serializeContact } from '../serializers';

const initialState = {
    isLoading: false,
    contactsList: []
};

export default (state = initialState, action) => {
    switch(action.type){
    case actionTypes.LOAD_CONTACTS_START:
        return {
            ...state,
            isLoading: true
        };
    case actionTypes.LOAD_CONTACTS_SUCCESS:
        return {
            ...state,
            isLoading: false,
            contactsList: action.payload.data.map(serializeContact),
        };
    case actionTypes.LOAD_CONTACTS_FAIL:
        return {
            ...state,
            isLoading: false,
            error: action.payload.error,
        };
    default: 
        return state;
    }
};